import React from 'react';
import SettingsIco from '@icons/ovb/settings.svg';
import HelpIco from '@icons/common/help.svg';
import { AUTO_INSIGHTS_HELP } from '@utils/help/links';
import {
  DrawerHeader, SettingsBtn, HelpLink, FlexFill,
} from './styled';

function Header({ openSettings }) {
  return (
    <DrawerHeader>
      <div style={{ flex: 1 }}>
        Automatic Insights
        {" "}
        <HelpLink href={AUTO_INSIGHTS_HELP} target="_blank" rel="noopener noreferrer"><HelpIco /></HelpLink>
      </div>
      {/* <FlexFill /> */}
      <SettingsBtn onClick={openSettings}>
        <SettingsIco />
      </SettingsBtn>
    </DrawerHeader>
  );
}

export default Header;
